import { Observable } from "rxjs";
import { PAYMENT_CONFIGURATIONS_SAVE, PAYMENT_CONFIGURATIONS_SAVE_COMPLETED } from "constants/action-types";
import siteConfig from "site-config";
import { formatMessage } from "lib/globalize-util";
import { ajax } from "lib/observable";
import "rxjs/add/operator/map";
import { add as snackbarAdd } from "actions/snackbars";

export const updatePaymentConfigurationsEpic = (action$, store) => {
    return action$
        .ofType(PAYMENT_CONFIGURATIONS_SAVE)
        .map((action) => {
            return action.payload;
        })
        .concatMap((configurations) => {
            return ajax({
                method: "POST",
                body: configurations,
                url: `${siteConfig.api}/api/v3.0/payment/configuration/create`,
            })
                .map(({ response, status }) => {
                    if (response && [200, 201].includes(status)) {
                        return { result: response, error: false };
                    } else {
                        return { error: true, result: [] };
                    }
                })
                .flatMap(({ result, error }) => {
                    if (error) {
                        return [
                            store.dispatch(
                                snackbarAdd({ message: formatMessage("Error saving payment configurations") })
                            ),
                            {
                                payload: new Error("Error saving payment configurations"),
                                error: true,
                                type: PAYMENT_CONFIGURATIONS_SAVE_COMPLETED,
                            },
                        ];
                    } else {
                        return [
                            {
                                payload: result,
                                type: PAYMENT_CONFIGURATIONS_SAVE_COMPLETED,
                            },
                            snackbarAdd({ message: formatMessage("Payment Configurations Updated!") }),
                        ];
                    }
                })
                .catch((error) => {
                    let errorMessage = formatMessage("Error saving payment configurations");

                    if (error?.xhr?.response?.message) {
                        errorMessage = "Error: " + error.xhr.response.message;
                    }

                    if (error.status === 401) {
                        errorMessage = formatMessage("You do not have permission to edit");
                    }

                    return Observable.merge(
                        Observable.of({
                            error: true,
                            payload: new Error(errorMessage),
                            type: PAYMENT_CONFIGURATIONS_SAVE_COMPLETED,
                        }),
                        Observable.of(snackbarAdd({ message: errorMessage }))
                    );
                });
        });
};
